import { supportedProviders } from '@/data/kycProviders';

export const PROVIDER_STORAGE_KEY = 'swipesign.kyc.lastProvider';
export const WEBID_CODE = 'webid';
const WEBID_DISPLAY = 'WebID';

export const rememberProvider = (providerCode: string): void => {
  localStorage.setItem(PROVIDER_STORAGE_KEY, providerCode);
};

export const readRememberedProvider = (): string | null => {
  return localStorage.getItem(PROVIDER_STORAGE_KEY);
};

export const resolveProviderName = (
  providerCode: string | null,
  fallback: string
): string => {
  if (!providerCode) {
    return fallback;
  }
  if (providerCode === WEBID_CODE) {
    return WEBID_DISPLAY;
  }
  const matched = supportedProviders.find(
    (provider) => provider.code === providerCode
  );
  return matched?.name ?? fallback;
};
